import "./relationshipHeader.scss";

import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { connect } from "react-redux";
import { PopoverBody } from "reactstrap";

import FocusedPopover from "../../components/popover/FocusedPopover";
import { withScreenContext } from "../../components/screen/ScreenContext";
import TreeListView from "../../components/treeList/TreeListView";
import { appStateOperations, appStateSelectors } from "../../modules/appState";
import batchOperations from "../../modules/batchOperations";
import { batchActions } from "../../modules/chainReducer";
import { relationshipViewSettingsSelectors } from "../../modules/definition/relationshipViewSettings";
import { itemOperations } from "../../modules/items";
import { uiStateOperations, uiStateSelectors } from "../../modules/uiState";
import { PropTypeShapes } from "../../types";
import { mergeDispatchToProps } from "../../utils/codeSplit";
import hasAncestorOfClass from "../../utils/hasAncestorOfClass";
import RelationshipCardHeaderView from "./RelationshipCardHeaderView";
import RelationshipColumnHeaderView from "./RelationshipColumnHeaderView";
import selectors from "./selectors";

// import debugUtils from "../../utils/debugUtils";

class RelationshipHeaderView extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      popoverOpen: false
    };
    this.toggleMenu = this.toggleMenu.bind(this);
    this.onColumnToggle = this.onColumnToggle.bind(this);
    this.onViewClick = this.onViewClick.bind(this);
  }

  componentWillMount() {
    this.setState({
      popoverOpen: false
    });
  }

  // componentWillReceiveProps(nextProps) {
  //   debugUtils.logPropChanges("RelationshipHeaderView", this.props, nextProps, true);
  // }

  toggleMenu() {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  }

  onColumnToggle(itemId, showColumn) {
    this.props.onColumnToggle(this.props.viewIds.first(), itemId, showColumn);
  }

  renderMenu() {
    return <TreeListView groups={this.props.allowedGroups} onChange={this.onColumnToggle} />;
  }

  renderSplitView() {
    let allowColumnDrag = true;
    //#!if iOS === true
// allowColumnDrag = this.props.screenContext.isEditMode;
    //#!endif

    const childComponents = [
      <RelationshipCardHeaderView key="cardHeader" onShowMenu={this.toggleMenu} {...this.props} />,
      <RelationshipColumnHeaderView key="columnHeader" {...this.props} allowColumnDrag={allowColumnDrag} />
    ];

    return <React.Fragment>{childComponents}</React.Fragment>;
  }

  onViewClick(e) {
    const clickWasItem = hasAncestorOfClass(e.target, "relationshipHeaderItemNameText");
    if (!clickWasItem) {
      this.props.onClick();
    }
  }

  render() {
    const settingsId = `relationshipHeader-${this.props.viewIds.first()}`;

    return (
      <div className="relationshipTableHeader" onClick={this.onViewClick}>
        {this.renderSplitView()}
        <FocusedPopover
          className="relationshipPopover"
          placement="bottom-start"
          hideArrow={false}
          isOpen={this.state.popoverOpen}
          target={settingsId}
          toggle={this.toggleMenu}
          modifiers={{
            shift: {
              enabled: true
            }
          }}
          trigger="legacy"
        >
          <PopoverBody onClick={e => e.stopPropagation()}>{this.renderMenu()}</PopoverBody>
        </FocusedPopover>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    selectedItemIds: uiStateSelectors.getSelectedItems(state.present),
    allowedGroups: selectors.getAllowedColumnGroupsForView(state.present, props.viewIds.first()),
    fontSize: appStateSelectors.getFontSize(state.present),
    isActiveView: appStateSelectors.isViewActive(state.present, props.viewIds.first()),
    showEntityColor: relationshipViewSettingsSelectors.getShowEntityColor(state.present)
  };
};

const readonlyActions = {
  onItemClick: appStateOperations.selectItems,
  onClick: appStateOperations.selectItems,
  onColumnToggle: appStateOperations.toggleRelationshipColumn,
  onShowInspector: uiStateOperations.showInspectorModal
};

const editingActions = {
  onLabelChange: itemOperations.editLabel,
  onMoveItem: (itemType, ids, targetId, placeAfter) => {
    let actions = [itemOperations.moveItemsNextToItem(itemType, ids, targetId, placeAfter)];
    //#!if iOS !== true
    actions.push(appStateOperations.selectItems(ids));
    //#!endif
    return batchActions(actions);
  },
  onCreateItemClick: batchOperations.createAndSelectItem,
  onShowInspector: appStateOperations.showRightPanel
};

const mapDispatchToProps = dispatch => mergeDispatchToProps(readonlyActions, editingActions, dispatch);

RelationshipHeaderView.propTypes = {
  fontSize: PropTypes.number.isRequired,
  viewIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  width: PropTypes.number.isRequired,
  colGroups: PropTypeShapes.relationshipColumnGroupList.isRequired,
  allowedGroups: PropTypeShapes.listOptionGroupList,
  onItemClick: PropTypes.func.isRequired,
  onLabelChange: PropTypes.func,
  onClick: PropTypes.func.isRequired,
  showEntityColor: PropTypes.bool.isRequired,
  onShowInspector: PropTypes.func,
  onColumnToggle: PropTypes.func.isRequired,
  isActiveView: PropTypes.bool.isRequired,
  selectedItemIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  onMoveItem: PropTypes.func.isRequired,
  onCreateItemClick: PropTypes.func.isRequired,

  //#!if iOS === true
  // From withScreenContext
// screenContext: PropTypes.object
  //#!endif
};

let exportView = connect(mapStateToProps, mapDispatchToProps)(RelationshipHeaderView);

//#!if iOS === true
// exportView = withScreenContext(exportView);
//#!endif

export default exportView;
